import type { WorkshopNavItem } from './workshopNavTypes';

export const WORKSHOP_REPORTS_SECTION_LABEL = 'Auto Workshop Reports';

export const WORKSHOP_REPORTS_NAV: WorkshopNavItem[] = [
    // Labels are display-only — the `resource` key drives routing and permission checks,
    // so trimming the trailing "Report" word here does not affect access control.
    { resource: 'jobCardSaleReport', label: 'Job Card Sale' },
    { resource: 'jobCardSaleDetailReport', label: 'Job Card Sale Detail' },
    { resource: 'jobCardProfitLossReport', label: 'Job Card Profit and Loss' },
    { resource: 'statementOfPartsOutflow', label: 'Statement of Parts Outflow' },
    { resource: 'stockIssuedNotInvoicedReport', label: 'Stock Issued But Not Invoiced' },
    { resource: 'jobCardBillingDetailReport', label: 'Job Card Billing Detail' },
    { resource: 'jobCardLaborDetailReport', label: 'Job Card Labor Detail' },
    { resource: 'jobCardRecoveryReport', label: 'Job Card Recovery' },
    { resource: 'crmFollowUpReport', label: 'CRM Sales Follow-Up' },
    { resource: 'salesTaxReturnReport', label: 'Sales Tax Return (PRA)' },
];
